import React from "react";
import { useTranslation } from "react-i18next";
import { AlertBubbleWarning } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { useSwitchAccount } from "@/services/auth/useSwitchAccount";
import { useIsSandboxAccount } from "@/services/auth/useIsSandboxAccount";

export const SANDBOX_BANNER_HEIGHT_PX = 36;

// Shown for as long as the active account is a sandbox; it has no close control
// on purpose, so the user can never lose track of which account they are in.
// The way back only appears when the sandbox was reached by switching.
export const SandboxBanner: React.FC = () => {
  const { t } = useTranslation();
  const isSandbox = useIsSandboxAccount();
  const { isLinkedAccount, switchToHome } = useSwitchAccount();

  if (!isSandbox) {
    return null;
  }

  return (
    <div
      role="status"
      className="h-9 flex w-full items-center justify-center gap-2 px-2 bg-badges-warning border-b border-badges-warning"
      data-test="sandbox-banner"
    >
      <IconContainer size="5" className="text-warning">
        <AlertBubbleWarning />
      </IconContainer>
      <Text className="text-center break-words">{t("sandbox.banner")}</Text>
      {isLinkedAccount && (
        <Button
          variant="tertiary"
          onClick={switchToHome}
          data-test="sandbox-banner-back-to-home"
        >
          {t("accountSwitch.backToHome")}
        </Button>
      )}
    </div>
  );
};
